<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>订单管理</el-breadcrumb-item>
      <el-breadcrumb-item>交易订单</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
<!--      <el-form-item label="商品名称">-->
<!--        <el-input size="small" clearable v-model="formInline.productName" placeholder="请输入商品名称"></el-input>-->
<!--      </el-form-item>-->
<!--      <el-form-item label="物流单号">-->
<!--        <el-input size="small" clearable v-model="formInline.logisticsNo" placeholder="请输入物流单号"></el-input>-->
<!--      </el-form-item>-->
      <el-form-item label="主订单编号">
        <el-input size="small" clearable v-model="formInline.outTradeNo" placeholder="请输入主订单编号"></el-input>
      </el-form-item>
      <el-form-item label="子订单编号">
        <el-input size="small" clearable v-model="formInline.shareDetailId" placeholder="请输入子订单编号"></el-input>
      </el-form-item>
      <el-form-item label="本地商品来源">
        <el-select
          size="small"
          clearable
          filterable
          v-model="formInline.productSource"
          placeholder="请选择本地商品来源"
        >
          <el-option
            v-for="item in productSourceOpts"
            :key="item.id + '-splykey'"
            :label="item.key"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="子订单状态">
        <el-select size="small" clearable v-model="formInline.tradeState" placeholder="请选择子订单状态">
          <el-option
            v-for="company in payway"
            :key="company.value"
            :label="company.key"
            :value="company.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="收货人姓名">
        <el-input size="small" clearable v-model="formInline.consigneeName" placeholder="请输入收货人姓名"></el-input>
      </el-form-item>
      <el-form-item label="交易状态">
        <el-select size="small" clearable filterable v-model="formInline.payState" placeholder="请选择交易状态">
          <el-option
              v-for="company in dealList"
              :key="company.value"
              :label="company.key"
              :value="company.value"
            ></el-option>
          </el-select>
      </el-form-item>
      <el-form-item label="订单创建时间">
          <el-date-picker
          size="small"
          v-model="dateRange"
          type="daterange"
          @change="dateChange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </el-form-item>
    </el-form>
    <el-row style="margin-bottom: 10px">
      <el-button size="small" type="info" plain icon="el-icon-upload2" @click="handleEdit">导出</el-button>
    </el-row>
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" @selection-change="selectChange" border element-loading-text="拼命加载中" style="width: 100%;">
<!--      <el-table-column align="center" type="selection" width="50">-->
<!--      </el-table-column>-->
<!--      <el-table-column align="center" type="index" width="60">-->
<!--      </el-table-column>-->
<!--      <el-table-column prop="productName" label="商品名称" width="120" show-overflow-tooltip>-->
<!--      </el-table-column>-->
      <el-table-column sortable prop="outTradeNo" label="主订单编号" width="180" show-overflow-tooltip>
      </el-table-column>
<!--      <el-table-column prop="transactionId" label="微信订单编号" width="120" show-overflow-tooltip>-->
<!--      </el-table-column>-->
<!--      <el-table-column prop="tradeStateDesc" label="交易状态描述	" width="120" show-overflow-tooltip>-->
<!--      </el-table-column>-->
      <el-table-column label="交易状态描述">
        <template slot-scope="scope">
          {{ getStatus(dealList,scope.row.payState)  }}
          <!-- {{scope.row.tradeState}} -->
        </template>
      </el-table-column>
      <el-table-column sortable prop="totalNum" label="订单数量" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="orderProductNames" label="子订单商品" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="productSources" label="子订单本地商品来源" width="160" show-overflow-tooltip>
<!--        <template slot-scope="scope">-->
<!--          <div v-if="scope.row.productSource">-->

<!--          </div>-->
<!--          <el-tag v-if="scope.row.productSource == 1">-->
<!--            {{ getDictKeyById(productSourceOpts, scope.row.productSource, "key") }}-->
<!--          </el-tag>-->
<!--          {{ getDictKeyById(productSourceOpts, scope.row.productSource, "key") }}-->
<!--        </template>-->
      </el-table-column>
      <el-table-column sortable prop="orderProductNos" label="子订单号" width="180" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="orderProductStatus" label="子订单状态" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="totalAmount" label="订单总金额" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="redemptionPoints" label="使用积分数" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="mchid" label="商户id" width="140" show-overflow-tooltip>
      </el-table-column>
      <el-table-column  prop="userName" label="收货人姓名" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="phone" label="收货人电话" width="120" show-overflow-tooltip>
      </el-table-column>
<!--      <el-table-column prop="address" label="物流地址" width="120" show-overflow-tooltip>-->
<!--      </el-table-column>-->
<!--      <el-table-column sortable prop="logisticsNo" label="物流单号" width="120" show-overflow-tooltip>-->
<!--      </el-table-column>-->
<!--      <el-table-column sortable prop="logisticsCompany" label="物流公司" width="120" show-overflow-tooltip>-->
<!--      </el-table-column>-->
      <el-table-column sortable prop="successDate" label="支付完成时间" width="160" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="freight" label="运费" width="100" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="thirdMsgs" label="第三方订单推送消息" width="100" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="createDate" label="创建时间" width="160" show-overflow-tooltip>
        <template slot-scope="scope">
          <div>{{scope.row.createDate|timestampToTime}}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" min-width="150" fixed="right">
        <template slot-scope="scope">
<!--          + scope.row.id-->
          <router-link :to="{path:'/pay/childrenOrder/'+scope.row.id}" class="link-type">
            <el-button size="mini"   type="primary" >详情</el-button>
          </router-link>

<!--          <el-button size="mini" :disabled="scope.row.tradeState!='SHIPPED' || scope.row.thirdFlag!='2'" type="primary" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>-->
<!--          <el-button size="mini" :disabled="scope.row.tradeState!='SHIPPED' || scope.row.thirdFlag=='2'" type="warning" plain @click="deleteUser(scope.row)">订单重推</el-button>-->
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="60%" @close="closeDialog('exportForm')">
      <el-form label-width="120px" :model="exportForm" ref="exportForm" :inline="true">

            <el-form-item label="订单状态">
              <el-select size="small" v-model="exportForm.tradeState" placeholder="请选择订单状态" >
                <el-option
                  v-for="company in payway"
                  :key="company.value"
                  :label="company.key"
                  :value="company.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="订单归属云仓">

              <el-select size="small" v-model="exportForm.thirdFlag" placeholder="请选择归属云仓" >
                <el-option
                  v-for="company in productSource"
                  :key="company.value"
                  :label="company.key"
                  :value="company.id"
                ></el-option>
              </el-select>
            </el-form-item>
        <el-form-item label="时间选择">
          <el-date-picker
            size="small"
            v-model="dateRange2"
            type="daterange"
            @change="dateChange2"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog('exportForm')">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('exportForm')">导出</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { OrderList, findExpreCompany,OrderUpdate,customdeclareredeclare} from '../../api/payMG'
import {timestampToTime} from '../../utils/util'
import Pagination from '../../components/Pagination'
import {Loading} from "element-ui";
import {exportOrder} from "@/api/system";
import exportFile from '@/utils/exportFile'
import {getDictByTypeId} from "../../api/system";
export default {
  data() {
    return {
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '预览',
      companyOption:[],
      payway: [
        { key: '待付款', value: 'PAID' },
        { key: '待发货', value: 'SHIPPED' },
        { key: '待收货', value: 'RECEIVED' },
        // { key: '待评价', value: 'EVALUATED' },
        { key: '已取消', value: 'CANCEL' },
        // { key: '支付失败', value: 'PAYERROR' },
        { key: '退货退款中', value: 'REFUNDGOODING' },
        { key: '退货退款成功', value: 'REFUNDGOOD' },
        { key: '退货退款失败', value: 'REFUNDGOODERR' },
        { key: '退款成功', value: 'REFUND' },
        { key: '订单完成', value: 'POSTSALE' },
        { key: '退款中', value: 'REFUNDING' },
      ],
      productSource:[],
      dealList:[
        {
          key:'未支付',value:'0'
        },
        {
          key:'已支付',value:'1'
        },
        {
          key:'已取消',value:'2'
        },
      ],
      dateRange:null,
      dateRange2:null,
      editForm: {
        id: '',
      },
      formInline: {
        pageNum: 1,
        pageSize: 10,
        logisticsNo:'',
        outTradeNo:'',
        tradeStateDesc:null,
        shareDetailId:null,
        consigneeName:null,

        // tradeState:'',
        // startDate: timestampToTime(new Date()),
        // endDate: timestampToTime(new Date()),
        startDate: '',
        endDate: '',
      },
      exportForm:{
        tradeState:null,
        thirdFlag:null,
        startDate: '',
        endDate: '',
      },
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      ids: '',
      productSourceOpts:[]
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {

    this.getdata(this.formInline);
    this.getDict()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取快递公司列表
    getCompanyList(){
     return findExpreCompany().then(res=>{
      return this.companyOption = res.body
      })
    },
    //获取字典数据
    getDict() {
      this.getDictById(32)
      //本地商品来源
      getDictByTypeId(33).then((res) => {
        this.productSourceOpts = res.body; //利润类型
      });
    },
    async getDictById(id) {
      const {body} =  await getDictByTypeId(id)
      this.productSource = body
    },
    dateChange(v){
      console.log(v);
      this.formInline.startDate	= v[0]
      this.formInline.endDate	= v[1]
    },
    dateChange2(v){
      console.log(v);
      this.exportForm.startDate	= v[0]
      this.exportForm.endDate	= v[1]
    },
    // 获取表格数据
    getdata(parameter) {
      this.loading = true
      OrderList(parameter)
        .then(res => {
          this.loading = false
          console.log(res.rsp_code)
          if (res.rsp_code !== 200) {
            this.$message({
              type: 'info',
              message: res.rsp_msg
            })
          } else {
            this.listData = res.rows
            console.log(this.listData);
            // 分页赋值
            this.pageparm.currentPage = this.formInline.pageNum
            this.pageparm.pageSize = this.formInline.pageSize
            this.pageparm.total = res.total
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('加载失败，请稍后再试！')
        })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.pageNum = parm.currentPage
      this.formInline.pageSize = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.formInline.pageNum=1
      this.getdata(this.formInline)
    },
    // selection选择
    selectChange(selection) {
      // console.log('selection',selection);
      // if (selection.length > 0) {
      //   this.isGroundingBtn = false
      // } else {
      //   this.isGroundingBtn = true
      // }
      let ids;
      ids = selection.map(item => item.id)
      this.ids = ids.join()
    },
    //显示编辑导出界面
    async handleEdit(index, row) {
      // await this.getCompanyList()
      this.title = "导出"
      // this.editForm = row
      this.editFormVisible = true
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          this.editFormVisible = false
          this.handleExport()

        } else {
          return false
        }
      })
    },
    // 删除公司
    deleteUser(row) {
      this.$confirm('确定要重推吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          customdeclareredeclare(row.id)
            .then(res => {
              if (res.rsp_code==200) {
                this.$message({
                  type: 'success',
                  message: res.rsp_msg
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.rsp_msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('操作失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog(formName) {
      this.editFormVisible = false
      this.$refs[formName].resetFields()
      this.exportForm= {
        tradeState:null,
        thirdFlag:null,
        startDate: '',
        endDate: '',
      }
    },
    getStatus(statusOption,statusName){
       let statusObj = statusOption.filter( statusItem => statusName == statusItem.value )
       return statusObj[0].key
    },
    /** 导出按钮操作 */
    handleExport() {
      // this.download('system/goods/export', {
      //   ...this.queryParams
      // }, `goods_${new Date().getTime()}.xlsx`)
      let downloadLoadingInstance;
      downloadLoadingInstance = Loading.service({
        text: "正在下载数据，请稍候",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      })
      exportOrder({...this.exportForm}).then(res => {
        exportFile.getExcel(res, `orderList_${new Date().getTime()}`)
        downloadLoadingInstance.close()
      }).catch(() => {
        downloadLoadingInstance.close()
      })
    },
    routerChild() {
      let that = this;
      that.$router.push({
        path: "/pay/Order/childrenOrder"
      });
    },
    // 根据字典id获取字典key
    getDictKeyById(options, id, keyString) {
      let key = "";
      options.forEach((item) => {
        if (item.id * 1 == id * 1) {
          key = item[keyString];
        }
      });
      return key;
    },
  }
}
</script>

<style scoped>
.el-select{
  width: 100%;
}
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>







// WEBPACK FOOTER //
// src/views/pay/Order.vue